"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledSearchMessageContainer = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
//
// properties
//
const config_1 = require("../../../assets/styles/config");
exports.StyledSearchMessageContainer = styled_components_1.default.div `
  align-items: center;
  background: white;
  border-top: 1px solid ${config_1.colors.pavement};
  display: flex;
  justify-content: center;
  padding-bottom: 50px;
  padding-top: ${({ topPadding }) => (topPadding ? '60px' : '0')}};
  border-radius: 0 0 6px 6px;
`;
